import axios from 'axios'
import { io } from 'socket.io-client'
import moment from 'moment-timezone'

import { alertActions } from "../_actions";


const isLocalhost = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1'
);

const isLive = process.env.REACT_APP_IS_LIVE !== undefined
  ? process.env.REACT_APP_IS_LIVE === 'true'
  : !isLocalhost;
const guessedTimezone = moment.tz.guess()

export let backendUrl = isLive
  ? `https://dev.pkrdcoin.com/api/`
  : `http://localhost:1220/api/`

export let SOCKET_SERVER_URL = isLive
  ? `https://socket.pkrdcoin.com`
  : `http://localhost:1220`

export function authHeader() {
  let user = JSON.parse(window.sessionStorage.getItem('PKRD_Administration'))
  if (user && user.token) {
    return { Authorization: 'Bearer ' + user.token } // returning an object
  } else {
    return {}
  }
}



export function logoutFunction() {
  window.sessionStorage.removeItem('PKRD_Administration')
  window.location.replace('/login')
  window.location.reload()
}

export const headerForPublicAPI = () => {
  const headers = new Headers()
  headers.append('Content-Type', 'application/json')
  return headers
}


export const headerForPrivateMediaAPI = () => {
  const token = authHeader()['Authorization']
  const headers = new Headers()

  if (token) {
    headers.append('Authorization', token)
  }
  // headers.append("Content-Type", "multipart/form-data");
  return headers
}

export const headerForPrivateAPI = new Headers({
  'Content-Type': 'application/json',
  Authorization: authHeader().Authorization
})

export const APIcallFunction = async credentials => {
  const requestOptions = {
    method: credentials.method,
    url: `${backendUrl}v1${credentials.endPoint}`,
    // Read the token for every request. A module-level Headers instance becomes
    // stale after login, token refresh, or switching administrator accounts.
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    data: credentials.body
  }
  //console.log("requestOptions", requestOptions);

  try {
    const response = await axios(requestOptions)
    const responseData = await handleResponse(response)
    return {
      data: responseData.data,
      message: responseData.message
    }
  } catch (error) {
    console.error('Error:', error.message)
    throw error
  }
}

export const APIcallFunctionMedia = async credentials => {
  const requestOptions = {
    method: credentials.method,
    headers: credentials.header,
    body: credentials.body
  }
  try {
    const response = await fetch(
      `${backendUrl}v1${credentials.endPoint}`,
      requestOptions
    )
    const resJson = await response.json()
    const responseData = await handleResponse(resJson)
    console.log('responseData', responseData)
    return {
      data: responseData
    }
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

export const apiCallFunctionSecond = async credentials => {
  const requestOptions = {
    method: credentials.method,
    headers: credentials.header,
    body: JSON.stringify(credentials.body)
  }
  try {
    const response = await fetch(
      `${backendUrl}v1${credentials.endPoint}`,
      requestOptions
    )

    const responseData = await handleResponseSecond(response)
    return {
      data: responseData
    }
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

export const APIcallFunctionForFile = async credentials => {
  try {
    const response = await axios.post(
      `${backendUrl}/v1/${credentials.endPoint}`,
      credentials.body,
      {
        headers: {
          Authorization: authHeader().Authorization,
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    const responseData = response.data.data
    console.log(responseData)
    return {
      data: responseData
    }
  } catch (error) {
    throw error
  }
}

function handleResponseSecond(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    console.log('datadata', data)
    if (data.code === 1403) {
      window.location.href = `${window.location.origin}/invalid-access`
    }
    if (!response.ok) {
      if (response.status === 401) {
        // logoutFunction();
      }
      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    if (data.error) {
      if (data.code === 3) {
        // logoutFunction();
      }
      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}

function handleResponse(response) {
  const { data, status } = response
  if (data?.code === 1403) {
    window.location.href = `${window.location.origin}/invalid-access`
  }

  if (status === 401) {
    logoutFunction()
    const error = data?.message || 'Unauthorized'
    return Promise.reject(error)
  }

  if (data?.error) {
    if (data?.code === 3) {
      logoutFunction()
    }
    const error = data?.message || 'Error occurred'
    return Promise.reject(error)
  }

  return data
}

export const downloadCSV = csv => {
  // const csv = convertToCSV(allFeeData);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'data.csv')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export function copyToClipboard(userAddress, index) {
  navigator.clipboard
    .writeText(userAddress)
    .then(() => {
      alertActions?.success('Copied to clipboard.')
    })
    .catch(err => {
      console.error('Failed to copy text: ', err)
    })
}

let socket = null;
let socketNotification = null;


// Function to initialize or reinitialize the socket
const initializeSocket = () => {
  const token = authHeader()?.Authorization // Get the latest token
  socket = io(SOCKET_SERVER_URL, {
    auth: {
      token // Pass the updated token
    },
    autoConnect: false // Do not auto-connect immediately
  });
  socketNotification = io(SOCKET_SERVER_URL, {
    auth: {
      token, // Pass the updated token
    },
    autoConnect: false, // Do not auto-connect immediately
  });
}

// Initialize socket for the first time
initializeSocket()

export const reconnectSocket = () => {
  initializeSocket() // Reinitialize socket with the latest token
}

export const socketConnection = (notification = false) => {
  return !notification ? socket : socketNotification;
};

export const connectSocket = chatId => {
  if (!socket.connected) {
    socket.connect()
  }
  if (chatId) {
    socket.emit('connected', { chatId })
  }
}

export const disconnectSocket = () => {
  if (socket.connected) {
    socket.disconnect()
  }
}

export const connectNotificationSocket = (userId) => {
  if (!socketNotification.connected) {
    socketNotification.connect();
  }
  if (userId) {
    socketNotification.emit("notification_connected", { userId, isAdmin: true });
  }
};

export const handleAutoLogoutUser = (userId) => {
  socketNotification.emit('auto_logout', { userId })
}

export function getMerchantStatusLabel(status) {
  const statusLabels = {
    pending: 'Pending',
    rejected: 'Rejected',
    approved: 'Approved',
    'contract-pending': 'Contract Pending',
    'contract-signed': 'Contract Signed',
    'contract-approved': 'Contract Approved',
    'contract-rejected': 'Contract Rejected',
    'verified-merchant': 'Verified Merchant',
    failed: 'Failed'
  }

  return status ? statusLabels[status] : 'Unknown Status'
}

export const formatDateByFormat = (value, format = 'MMM D, YYYY - hh:mm A') => {
  return moment(value).tz(guessedTimezone).format(format)
}

export function stripHtml(html) {
  if (html === undefined || html === null) return "";
  const text = String(html);
  if (!/[<&]/.test(text)) return text;
  if (typeof DOMParser === "undefined") return text.replace(/<[^>]*>/g, "").trim();
  const doc = new DOMParser().parseFromString(text, "text/html");
  return (doc.body?.textContent || "").trim();
}

const configPermissions =
  JSON.parse(window.sessionStorage.getItem('PKRD_Administration'))?.config || {}
export const role =
  JSON.parse(window.sessionStorage.getItem('PKRD_Administration'))?.roleId || 0
export const userId =
  JSON.parse(window.sessionStorage.getItem('PKRD_Administration'))?.userId || ''
export const adminData =
  JSON.parse(window.sessionStorage.getItem('PKRD_Administration')) || {}

export function checkConfigPermissions(key) {
  if (role !== 1) {
    if (configPermissions.hasOwnProperty(key)) {
      return configPermissions[key]
    } else {
      return false
    }
  } else {
    return true
  }
}


export const formatCrypto = (val, max = 8) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: max,
  }).format(val);
};

export function capitalizeWords(str = "") {
  return str
    .toLowerCase()
    .replace(/\b\w/g, char => char.toUpperCase());
}
